import { CrudFormItemProps, CrudFormModal, nameof } from "digimuth-components/dist";
import { Checkbox, Select } from "antd";
import PricesListContainer from "../../priceLower/priceListContainer";
import {
    MenuCategoryDto,
    MenuEntryCreateDto,
    MenuEntryUpdateDto,
    PriceCreateDto,
    PriceDto,
    PriceUpdateDto
} from "../../../api";

const { Option } = Select;

const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 24 },
    layout: 'horizontal',
    colon: false
};

export default function MenuEntryModalForm(props: MenuEntryModalProps) {
    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<MenuEntryCreateDto>("name"),
            rules: [
                { required: true, message: 'To pole jest wymagane' }
            ],
            label: "Nazwa"
        },
        {
            name: nameof<MenuEntryCreateDto>("description"),
            rules: [ { required: false } ],
            label: "Opis"
        },
        {
            name: nameof<MenuEntryCreateDto>("isVegan"),
            label: " ",
            children: <Checkbox>Wegańskie</Checkbox>,
            valuePropName: 'checked'
        },
        {
            name: nameof<MenuEntryCreateDto>("isGlutenFree"),
            label: " ",
            hideLabel: true,
            children: <Checkbox>Bez glutenu</Checkbox>,
            valuePropName: 'checked'
        },
        {
            name: nameof<MenuEntryCreateDto>("isGlutenFreeAvailable"),
            label: " ",
            children: <Checkbox>Zapytaj o gluten free</Checkbox>,
            valuePropName: 'checked'
        },
        {
            name: nameof<MenuEntryCreateDto>("isDairyFree"),
            label: " ",
            children: <Checkbox>Bez laktozy</Checkbox>,
            valuePropName: 'checked'
        }
    ];

    if (props.initialValues !== null) {
        formItems.push({
            name: nameof<MenuEntryCreateDto>("menuCategoryId"),
            label: "Kategoria",
            rules: [
                { required: true, message: 'To pole jest wymagane' }
            ],
            children: <Select>
                {props.menuCategories?.map(x =>
                    <Option key={x.id!} value={x.id!}>{x.name}</Option>
                )}
            </Select>
        })
    }

    formItems.push({
        name: "Ceny",
        children: <PricesListContainer
            menuEntryId={props.initialValues?.id!}
            onSubmit={props.onPriceSubmit}
            onEdit={props.onPriceEdit}
            onPriceDelete={props.onPriceDelete}
        />
    })

    return <CrudFormModal
        formItems={formItems}
        onSubmit={props.onSubmit}
        forceRender={true}
        destroyOnClose={true}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalCancelText={props.cancelButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        formProps={layout}
        width={800}
    />;
}

interface MenuEntryModalProps {
    initialValues?: MenuEntryCreateDto | MenuEntryUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: MenuEntryCreateDto | MenuEntryUpdateDto) => Promise<any>,
    onPriceSubmit: (value: PriceCreateDto | PriceUpdateDto) => void,
    onPriceEdit: (values: PriceUpdateDto[]) => void,
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string,
    menuCategories: MenuCategoryDto[] | null,
    onPriceDelete: (record: PriceDto) => void;
}
